import React from 'react';

/**
 * Render Merlin's `**bold**` emphasis inside CSR-facing warning text.
 *
 * Merlin's extraction prompt tells him to bold the one decisive token
 * (SKU, price, carrier) with double asterisks; this renders those spans as
 * <strong> without any HTML parsing — everything else stays plain text, so
 * arbitrary email content can never inject markup. An unpaired `**` renders
 * literally.
 */
export function renderInlineBold(text: string): React.ReactNode {
  if (!text.includes('**')) return text;
  const parts = text.split('**');
  // An even part count means the final `**` was unpaired — render it back.
  if (parts.length % 2 === 0) {
    const tail = parts.pop() ?? '';
    parts[parts.length - 1] = `${parts[parts.length - 1]}**${tail}`;
  }
  return parts.map((part, i) =>
    i % 2 === 1 ? <strong key={i}>{part}</strong> : part,
  );
}

export default renderInlineBold;
